<app-navsec></app-navsec>
<div class="container mt-5 animated fadeIn">
    <hr>
    <div class="row">
        <div class="col-lg-12">
            <div class="row">
                <div class="col-lg-6">
                    <form class="form-inline">
                        <div class="col-lg-12">
                            <div class="row">
                                <label for="formControlRange"><p class="titulo" style="font-size: 18px;"><b>Buscar por producto, enfermedad, o por parte del cuerpo:</b></p></label>
                                <input class="form-control inp mt-2" [(ngModel)]="filterProducto" name="filterProducto" type="search" placeholder="Ej...colágeno, artritis, huesos" aria-label="Search" autocomplete="off">
                                <button class="btnshc mt-2"><i class="fa fa-search"></i></button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-6">
                    <form>
                        <div class="form-group">
                            <label for=""><p class="titulo" style="font-size: 18px;"><b>Filtrar Precio:</b></p></label>
                            <input type="range" id="slider" class="form-control-range rng" min="0" max="300000" step="1000" value="0" (change)="value($event.target.value)">
                            <div class="text-right mt-3">
                                <label class="mr-2"><p>Precio Máximo: <b style="font-size: 18px;">{{rango | currency}}</b></p></label>
                                <button class="filtrar" (click)="findPrice()">Buscar</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="col-lg-12 mt-5">
        <div class="row row-cols-1 row-cols-md-4">
            <div class="col mb-3" *ngFor="let item of lista | filter:filterProducto">
                <div class="card h-100 games" (click)="openProduct(item.id)">
                    <img [src]="item.imagen" class="card-img-top prd" alt="...">
                    <div class="card-body">
                        <h5>{{item.nombre }}</h5>
                        <h5>{{item.presentacion }}</h5>
                    </div>
                    <div class="card-footer">
                        <div class="text-right">
                            <span *ngIf="item.descuento > 0" class="notify-badge">-{{item.descuento}}%</span>
                        </div>
                        <div class="text-center mb-2">
                          <h5 *ngIf="item.descuento > 0" class="card-text"><b style="color: red;text-decoration: line-through;">${{item.precio | number: '1.0-0'}}</b> - <b>${{item.precio - ((item.precio * item.descuento)/100) | number: '1.0-0'}}</b> </h5>
                          <h4 *ngIf="item.descuento == 0" class="card-text"><b>${{item.precio | number}}</b></h4>
                        </div>
                        <button class="btn btn-light btnPer" style="width: 100%;"><i class="fa fa-shopping-cart" aria-hidden="true"></i> COMPRAR</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
